<template>
  <div class="activity">
    <tab-list :tabList="tabBar" @tabClick="tabClick" :cur="activeTab"></tab-list>
    <div class="scroll">
      <scroll
        v-if="orderArr.length"
        :data="orderArr"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
      >
        <div
          class="list_box"
          @click="goDetail(item.orderNo)"
          v-for="(item,index) in orderArr"
          :key="index"
        >
          <div class="list_box_top">
            <span class="createTimeCN">{{item.createTime | formatTime(8)}}</span>
            <div class="rightBox">
              <span
                v-if="item.isFree === 2 && item.status === 0 && item.lastPayTime-Date.parse(new Date()) > 0"
                class="time_last"
              >剩余时间：{{item.expiryTime | toS}}</span>
              <span class="right_order_status">{{item | numToText}}</span>
            </div>
          </div>
          <div class="list_box_center">
            <img class="logo" :src="item.actImgPath" />
            <div class="center_right_box">
              <p class="center_right_title">{{item.actTitle}}</p>
              <p class="center_right_address">{{item.actAddress}}</p>
              <p
                class="time_date"
              >{{item.actBegTime | formatTime(6)}} 至 {{item.actEndTime | formatTime(6)}}</p>
              <p class="total_title" v-if="item.isFree === 1">免费</p>
              <p class="total_title" v-if="item.isFree === 2">¥ {{item.payAmount|priceFormat}}</p>
              <p class="total_title" v-if="item.isFree === 3">¥ {{item.payAmount|priceFormat}}(线下支付)</p>
            </div>
          </div>
          <div class="list_box_bottom buttonBox" v-if="item.status == 4 || item.refundTime">
            <span class="backPay">退款金额: ¥ {{item.payAmount|priceFormat}}</span>
            <span class="evaluate_btn">查看详情</span>
          </div>
          <div class="list_box_bottom" v-else>
            <span
              v-if="item.status == 0"
              class="cancel"
              @click.stop="cancelOrderByOrderId(index)"
            >取消订单</span>
            <span
              v-if="item.status == 0"
              class="evaluate_btn pay_btn"
              @click.stop="goPayCenter(item.orderNo,item.actId)"
            >立即支付</span>
            <span
              v-if="item.status == 1 || item.status == 3 || item.status == 2 || (item.status==5 && !item.hasTemp)"
              class="evaluate_btn"
            >查看详情</span>
            <!-- <span v-if="item.status == 5 && item.isFree === 2" class="cancel">申请发票</span> -->
            <span
              v-if="item.status == 5 && item.isEvaluate == 0 && item.hasTemp"
              class="evaluate_btn"
              @click.stop="evaluate(item)"
            >去评价</span>
            <span
              v-if="item.isEvaluate == 1"
              class="evaluate_btn"
              @click.stop="viewEvaluation(item)"
            >查看评价</span>
          </div>
        </div>
      </scroll>
      <no-message v-if="!orderArr.length && loaded"></no-message>
    </div>
  </div>
</template>

<script>
import tabList from '../../../components/tabbar';
import Scroll from '../../../components/scroll';
import NoMessage from '../../../components/nomessage';
import util from '../../../utils/util';
import {
  getActOrderListByUserId,
  cancelOrderByOrderId
} from '../../../utils/api';
import { mapState } from 'vuex';
import ping from '../../../utils/pingpay.js'
export default {
  name: 'activityList',
  props: {
    selectTab: Number
  },
  components: {
    tabList,
    Scroll,
    NoMessage
  },
  filters: {
    numToText: value => {
      if (value.status === 0) {
        return '待支付';
      } else if (value.status === 1) {
        return '已取消'; // 用户主动取消
      } else if (value.status === 2) {
        if (value.refundTime) {
          return '退款中';
        } else {
          return '已支付';
        }
      } else if (value.status === 3) {
        return '已取消'; // 过期取消
      } else if (value.status === 4) {
        return '已退款';
      } else if (value.status === 5) {
        return '已结束';
      } else if (value.status === 6) {
        return '已过期';
      } else {
        return '未定义';
      }
    },
    toS: function (value) {
      return util.lastTime(value)
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  activated() {
    if (this.common.isChange && this.selectTab === 0) {
      this.$store.commit('isChange', false);
      this.getActOrderListByUserId();
    }
  },
  watch: {
    $route(to, from) {
      if (this.selectTab === 0) {
        // 来源活动订单或者订单详情刷新列表
        if (
          from.name === 'activityOrderDetail' ||
          from.name === 'activityForm' ||
          from.name === 'activitySuccess' || from.name === 'evaluateSuccess' ||
          from.name === 'evaluate'
        ) {
          this.pageSize = 1;
          this.getActOrderListByUserId();
        }
      }
    }
  },
  data() {
    return {
      tabBar: ['全部', '待支付', '已支付', '已结束', '退款'],
      orderArr: [],
      activeTab: 0,
      pageNo: 1,
      loaded: false,
      canPay: true,
      allLoaded: false
    };
  },
  created() {
    this.getActOrderListByUserId();
  },
  methods: {
    viewEvaluation(item) {
      this.$router.push(`/evaluate/viewEvaluate?id=${item.id}`);
    },
    evaluate(item) {
      console.log(item);
      this.$router.push(
        `/evaluate/evaluate?id=${item.id}&referenceName=${
        item.actTitle
        }&templateType=1&referenceNo=${item.orderNo}`
      );
    },
    goPayCenter(orderNo, actId) {
      if (!this.canPay) { return; }
      this.canPay = false;
      let params = {
        orderNo: orderNo,
        repairNo: '', // "报修单号",
        bussinessType: "2",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode: actId,
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      ping(
        params,
        '',
        res => {
          console.log(res);
          this.canPay = true;
          this.getActOrderListByUserId()
        },
        () => {
          this.canPay = true;
          this.getActOrderListByUserId()
        },
        () => {
          this.canPay = true;
          this.getActOrderListByUserId()
        }
      );
      setTimeout(() => {
        this.canPay = true
      }, 1000)
    },
    // 取消订单
    cancelOrderByOrderId(index) {
      util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
        cancelOrderByOrderId(
          {
            orderId: this.orderArr[index].id,
            type: 0
          },
          { userId: this.common.userId, openId: this.common.openId }
        ).then(res => {
          if (res.res.code === 10000) {
            this.orderArr[index].status = 1;
          }
        });
      });
    },
    goDetail(id) {
      this.$router.push(`/activityOrder?id=${id}`);
    },
    tabClick(val) {
      this.activeTab = val;
      this.pageNo = 1;
      this.getActOrderListByUserId();
    },
    getActOrderListByUserId() {
      this.allLoaded = false;
      let params = {
        userId: this.common.userId,
        type: this.activeTab,
        pageNo: this.pageNo,
        pageSize: 10,
        actType: 1
      };
      getActOrderListByUserId(params, {
        userId: this.common.userId,
        openId: this.common.openId
      }).then(res => {
        console.log(res);
        this.loaded = true;
        if (res.res.code === 10000) {
          if (res.body.orderList.length !== 10) {
            this.allLoaded = true;
          }
          if (this.pageNo === 1) {
            this.orderArr = res.body.orderList;
          } else {
            this.orderArr = [...this.orderArr, ...res.body.orderList];
          }
        }
      });
    },
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getActOrderListByUserId();
    },
    loadData() {
      this.pageNo = 1;
      this.getActOrderListByUserId();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.activity {
  height: 100%;
  .flex(column);
  .scroll {
    flex: 1;
    height: 500px;
  }
}
.line {
  margin: 0 30px;
  height: 1px;
  .borderB();
}
.loading_text {
  width: 100%;
  height: 80px;
  line-height: 80px;
  color: #c9c9c9;
  .fontSize(14px);
  text-align: center;
}
.list {
  background-color: rgba(243, 244, 246, 1);
  width: 100%;
}

/*-----------中间信息列表模块---------*/
.list_box {
  background: #fff;
  margin: 20px;
  border-radius: 8px;
  padding: 20px;
}

.list_box_top {
  height: 34px;
  padding-bottom: 20px;
  .flex();
  justify-content: space-between;
  align-items: center;
}

.createTimeCN {
  .fontSize(13px);
  color: @color9;
}

.rightBox {
  .flex();
  align-items: center;
  justify-content: flex-end;
}

.right_order_status {
  .fontSize(13px);
  color: @color17;
}
.list_box_center {
  .flex();
  padding: 18px 0;
}

.logo {
  width: 240px;
  height: 168px;
  margin-right: 20px;
}

.center_right_box {
  width: 410px;
}

.center_right_title {
  .fontSize(14px);
  .textOver(100%);
  color: @color3;
  line-height: 40px;
  font-weight: bold;
  margin-bottom: 8px;
}

.center_right_address {
  .fontSize(12px);
  color: @color6;
  line-height: 37px;
  .textOver(100%);
}

.time_date {
  .fontSize(13px);
  color: @color6;
  line-height: 37px;
  margin-top: 8px;
}

.list_box_bottom {
  .flex();
  justify-content: flex-end;
  align-items: center;
}

.buttonBox {
  .flex();
  justify-content: space-between;
  align-items: center;
}

.backPay {
  .fontSize(13px);
  display: block;
  color: @color6;
}

.time_last {
  .fontSize(12px);
  color: #fc3f56;
  line-height: 36px;
  padding: 0 14px;
  margin-right: 20px;
  background: rgba(252, 63, 86, 0.1);
  border-radius: 4px;
}

.total_title {
  line-height: 30px;
  .fontSize(14px);
  color: @color3;
  margin-top: 10px;
}

.cancel {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  .border(#dadada);
  .fontSize(13px);
  color: #666666;
  line-height: 52px;
  text-align: center;
  margin-left: 20px;
  box-sizing: border-box;
}

.evaluate_btn {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  border: 0.015rem solid #dadada;
  .fontSize(13px);
  color: @color6;
  line-height: 52px;
  text-align: center;
  margin-left: 20px;
  box-sizing: border-box;
}
.pay_btn {
  color: @color17;
  box-sizing: border-box;
  .border(#96aaf0);
  background: rgba(243, 245, 253, 1);
}
</style>
